import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  InputGroup,
  Input,
  Modal,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import _ from "lodash";

const PopConfirm = ({ onOk }) => {
  const [modal, SetModal] = useState(false);

  const handleConfirm = () => {
    if (onOk) onOk();
    SetModal(false);
  };

  return (
    <>
      <Button
        color="danger"
        outline
        style={{ marginLeft: 5 }}
        onClick={() => SetModal(!modal)}
        size="sm"
      >
        Delete
      </Button>
      <Modal isOpen={modal} toggle={() => SetModal(false)}>
        <ModalHeader
          className="confirm-modal-header"
          style={{ paddingBottom: 0 }}
        >
          Are you sure to delete this path?
        </ModalHeader>
        <ModalFooter className="confirm-modal-footer" style={{ paddingTop: 0 }}>
          <Button color="danger" size="sm" onClick={handleConfirm}>
            <i className="far fa-trash-alt" style={{ marginRight: 5 }} />
            Continue
          </Button>{" "}
          <Button size="sm" outline onClick={() => SetModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

function EditHook({ data, index = "new", open, onClose, update }) {
  const [path, setPath] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setPath(data);
  }, [open]);

  const handleSave = async () => {
    if (!path) return;
    try {
      setSaving(true);
      await update(index, "add", path);
      onCancel();
    } catch (error) {
      console.log("error", error);
    }
    setSaving(false);
  };

  const handleDelete = async (id = data.Id) => {
    try {
      update(index, "delete");
    } catch (error) {
      console.log("error", error);
    }
  };

  // closing edit tab
  const onCancel = () => {
    setPath("");
    if (onClose) onClose();
  };

  return (
    <div>
      <InputGroup style={{ marginTop: 3, marginBottom: 10 }}>
        <Input
          placeholder="/example"
          value={path}
          onChange={(e) => setPath(e.target.value)}
          style={{ borderRadius: 0, paddingLeft: 10 }}
        />

        {!data && (
          <Button
            color="primary"
            style={{ marginLeft: 20 }}
            onClick={handleSave}
          >
            {saving && (
              <span
                style={{ marginRight: 10 }}
                className="spinner-border spinner-border-sm"
              />
            )}
            Add
          </Button>
        )}
      </InputGroup>

      {data && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <PopConfirm onOk={handleDelete} />
          <div style={{ display: "flex" }}>
            <Button
              color="secondary"
              outline
              style={{ marginLeft: 5 }}
              onClick={onCancel}
              size="sm"
            >
              Cancel
            </Button>
            <Button
              color="primary"
              style={{ marginLeft: 5 }}
              onClick={handleSave}
              size="sm"
            >
              {saving && (
                <span
                  style={{ marginRight: 10 }}
                  className="spinner-border spinner-border-sm"
                />
              )}
              Update
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditHook;
